import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { STEPS } from "@/lib/site";

export const HowItWorks = () => {
  return (
    <section id="how" className="relative py-24 sm:py-32" data-testid="how-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <Reveal className="mb-16 max-w-2xl">
          <p className="mb-3 text-xs uppercase tracking-[0.25em] text-[#F0C674]/80">
            Глава 02 — Путь к разбору
          </p>
          <h2 className="font-serif text-4xl font-bold text-[#EDE6D3] sm:text-5xl lg:text-6xl">
            Как это <span className="text-gold-gradient">работает</span>
          </h2>
        </Reveal>

        <div className="relative">
          {/* Dashed gold connector (desktop) */}
          <div className="dashed-gold absolute left-0 right-0 top-8 hidden h-0.5 lg:block" aria-hidden="true" />

          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
            {STEPS.map((step, i) => (
              <Reveal key={step.n} delay={i * 0.12} className="relative">
                {/* Opaque halo wider than the circle's glow-gold bleed, so the dashed
                    line behind never peeks through the glow near the circle's edge. */}
                <span
                  className="absolute -left-6 -top-6 z-[5] hidden h-28 w-28 rounded-full bg-[#0B0B1F] lg:block"
                  aria-hidden="true"
                />
                <motion.span
                  className="relative z-10 flex h-16 w-16 items-center justify-center rounded-full border border-[#D4AF6E]/40 bg-[#0B0B1F] font-serif text-2xl font-bold text-gold-gradient glow-gold"
                  whileHover={{ scale: 1.08 }}
                >
                  {step.n}
                </motion.span>
                <h3 className="mt-5 font-serif text-2xl font-semibold text-[#EDE6D3]">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[#EDE6D3]/60">
                  {step.text}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
